import React from 'react';
import cn from 'classnames';
import {StandardProps} from '.';

export interface LinkProps extends StandardProps<React.AnchorHTMLAttributes<HTMLAnchorElement>> {
  component?: React.ElementType;
  color?: 'primary' | 'textPrimary' | 'error';
  disabled?: boolean;
}

export const Link: React.FC<LinkProps> = ({className, component, children, color, ...restProps}) => {
  const Component = component || 'a';

  return (
    <Component
      className={cn('link', className, {
        'link-button': component === 'button'
      },
        color ? `color-${color}` : ''
      )}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export default Link;
